import { Component } from "@angular/core";
import { ICellRendererParams } from "ag-grid-community";
import { ClassificationService } from "../../../../pages/classification/classification.service";
import { ToastService } from "../../../../@theme/service/toast.service";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { Router } from "@angular/router";
import { FeedbackService } from "../../../../pages/feedback/feedback.service";
import { ProductModTargetType } from "../../../type/product-mod-target-type";

@Component({
  selector: 'ngx-classification-search-column',
  template: ` <nb-icon class="mr-1" *ngIf="params.value" icon="search-outline" style="cursor: pointer" status="primary" (click)="onClickSearch()"></nb-icon>
                <ngx-tag value="{{params.value}}" status="not-applied" (click)="onClickSearch()" style="cursor: pointer"></ngx-tag>
               `,
})
export class ClassificationSearchComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public data: any;

  constructor(
    private classificationService: ClassificationService,
    private toast: ToastService,
    private router: Router,
    private feedbackService: FeedbackService,
  ) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
  }

  ngOnInit() {}

  onClickSearch() {
    if (this.data.targetType === ProductModTargetType.FEEDBACK) {
      this.goToFeedback();
    } else {
      this.goToClassification();
    }
  }

  goToFeedback() {
    this.feedbackService.findOne(this.data.ticketId).subscribe(res => {
      if (res && res.result) {
        this.router.navigate([`pages/feedback/${res.data.id}`]);
      } else {
        this.toast.showToast('warning', '피드백정보가 존재하지 않습니다.');
      }
    }, err => {
      console.error(err);
      this.toast.showToast('danger', '피드백ID 조회중 알 수 없는 문제 발생.');
    });
  }

  goToClassification() {
    this.classificationService.findOne(this.data.ticketId).subscribe(res => {
      if (res && res.result) {
        this.router.navigate([`pages/classification/${res.data.id}`]);
      } else {
        this.toast.showToast('warning', '티켓정보가 존재하지 않습니다.');
      }
    }, err => {
      console.error(err);
      this.toast.showToast('danger', '티켓ID 조회중 알 수 없는 문제 발생.');
    });
  }
}